export default __webpack_public_path__ + "static/media/STRIP-Logo1.5972b5bd.png";